export default "__VITE_ASSET__Bb$rxlw4__"